import {DefaultPageProps} from "@models/DefaultProps.ts";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";
import {useEffect, useMemo, useState} from "react";
import {ILog} from "@models/seguranca/ILog.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {UsuarioLogItemRow} from "@components/shared/item/LogItemRow.tsx";
import {Table, TableBody, TableCell, TableHead} from "@mui/material";

interface UsuarioLogsPageProps extends DefaultPageProps<{ usuarioId?: number }> {
}

export function UsuarioLogsPage(props: UsuarioLogsPageProps) {
    const {getUsuarioLogs} = useUsuario()

    const [logs, setLogs] = useState<ILog[]>([])
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10})

    const usuarioId = useMemo(() => {
        return props.filtersProps?.filters.usuarioId ?? 0
    }, [props.filtersProps?.filters])

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination(prev => ({...prev, page: 1}))
            return;
        }

        setPagination(prev => ({...prev, loading: true}))
        getUsuarioLogs({data: {usuarioId: usuarioId}, pagination: pagination}).then(x => {
            if (x.items != null) {
                setLogs(x.items)
            }
            setPagination(prev => ({...prev, ...x.pagination, loading: false, ignoreCache: false}))
        })

    }, [pagination.page, pagination.ignoreCache == true, usuarioId]);

    return (<DefaultContainer pageProps={{pagination, setPagination}} titulo={'Logs do usuario'}>
        {/*<TableContainer>*/}
        <Table size={'small'}>
            <TableHead>
                <TableCell>Usuario</TableCell>
                <TableCell>Data/Hora</TableCell>
                <TableCell>Detalhes</TableCell>
            </TableHead>
            <TableBody>
                {logs.map(x => <UsuarioLogItemRow value={x} key={x.id}/>)}
            </TableBody>
        </Table>
        {/*</TableContainer>*/}
    </DefaultContainer>)
}